export const TABS = {
  MEMBERS: 'members',
  JOIN_REQUESTS: 'join-requests',
  RELATIONS: 'relations',
};
